import * as React from 'react'
import * as pbi from 'powerbi-client';

declare var powerbi: pbi.service.Service;


export class ReportVisual extends React.Component<any, any> {
    component: any;
    rootElement: HTMLDivElement;

    constructor(props) {
        super(props);
        this.component = null;
        this.state = {
            type: 'visual'
        };
    }

    componentDidMount() {
        this.updateState(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.updateState(nextProps);
    }

    componentDidUpdate(prevProps) {
        if (this.validateConfig(this.state)) {
            return this.embed(this.state);
        }
    }

    componentWillUnmount() {
        this.reset();
    }

    embed(config) {
        try {
            this.reset();
            var report : any = this.component = powerbi.embed(this.rootElement, config);


            report.on("loaded", function () {

                var filterTargetLevel = report.page('ReportSection50c136b02945f18d6a0e');
                

                //filterTargetLevel.getFilters()

                //    .then((res) => {
                //        alert(res);
                //        var string = JSON.stringify(res);
                //        alert('got filter')
                //    });

                //filterTargetLevel.getVisuals()
                //    .then(function (visuals) {
                        // Retrieve the wanted visual.
                        //var slicer = visuals.find(function (visual) {
                        //    return visual.type == "slicer" && visual.name == "f02efd950a1cf1f2426b";
                        //});

                        //slicer.setSlicerState({ filters: [filter] })
                        //    .then(function () { })
                        //    .catch(errors => {
                        //        alert('Errors');
                        //        alert(errors)
                        //    });

                        //var slicer1 = visuals.find(function (visual) {
                        //    return visual.type == "slicer" && visual.name == "f97e1a23aaa3c09491b1";
                        //});

                        //slicer1.setSlicerState({ filters: [filterDate] })
                        //    .then(function () { })
                        //    .catch(errors => {
                        //        alert('Errors');
                        //        alert(errors)
                        //    });

                        //.visual('979239427cad7e9c04e8');
                        //filterTargetLevel.removeFilters()
                        //    .then(function () { alert('removed filter') })
                        //    .catch(errors => { alert(errors) });
                        //filterTargetLevel.setFilters([filter])
                        //    .then(function () {alert('set filter')})
                        //    .catch(errors => { alert(errors) });


                    //});
            });
            
            if (this.props.onEmbedded) {
                this.props.onEmbedded(this.component);
            }
            return this.component;
        }
        catch (err) {

        }
    }

    reset() {
        powerbi.reset(this.rootElement);
        this.component = null;
    }

    updateState(props) {
        const nextState = Object.assign({}, this.state, props, {
            
            settings: {
                filterPaneEnabled: true,
                navContentPaneEnabled: this.props.navContentPaneEnabled
            }
        });
        /**
         * This property must be removed from the state object so that it doesn't get used in the embedConfig.
         * This would be passed to `powerbi.embed(element, embedConfig)` and attempted to be sent over postMessage;
         * however, functions cannot be cloned and it will fail.
         */
        delete nextState.onEmbedded;
        this.setState(nextState);
    }

    validateConfig(config) {
        const errors = pbi.models.validateReportLoad(config);
        return (errors === undefined);
    }

    render() {
        return (
            <div style={{ position: 'absolute', bottom: '3px', top: '0', left: '0', right: '0' }} ref={(ref) => this.rootElement = ref}></div>
        )
    }
}

export default ReportVisual;


// WEBPACK FOOTER //
// ./src/components/powerBIComponents/ReportVisual.tsx